import CarouselLinks from 'shared/assets/scripts/carouselLinks'

export default class TabsSubCategory {
	private tabsSubCategory: HTMLElement | null
	private isDesktop: boolean

	constructor() {
		this.tabsSubCategory = document.querySelector('.tabsSubCategory')
		this.isDesktop = window.matchMedia('(min-width: 1000px)').matches
	}

	init() {
		if (this.isDesktop && this.tabsSubCategory) {
			const carouselLinks = new CarouselLinks(this.tabsSubCategory)
			carouselLinks.init()
		}
	}
}
